import type { Dictionary } from './i18n/types';

/**
 * Map known report enum cell values to the active locale.
 *
 * Column headings already come from the server with LabelTH when locale=th;
 * row values for kind/status/doc_type are still the raw Postgres enum text
 * (`usage`, `failed`, …). Only those closed vocabularies are rewritten —
 * model ids, providers, and free-text reasons stay as returned.
 */
export function localizeReportCell(
  columnKey: string,
  raw: string,
  reports: Dictionary['reports'],
): string {
  switch (columnKey) {
    case 'kind':
      return reports.ledgerKind[raw as keyof typeof reports.ledgerKind] ?? raw;
    case 'doc_type':
      return reports.invoiceDocType[raw as keyof typeof reports.invoiceDocType] ?? raw;
    case 'status':
      return (
        reports.usageStatus[raw as keyof typeof reports.usageStatus] ??
        reports.invoiceStatus[raw as keyof typeof reports.invoiceStatus] ??
        reports.reconciliationStatus[raw as keyof typeof reports.reconciliationStatus] ??
        raw
      );
    default:
      return raw;
  }
}
